import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import MonteCarloChart from './MonteCarloChart';

import '../MonteCarlo.scss';

class WallboardMonteCarloChart extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Monte Carlo: Delivery Date</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="mc" showNavigator />
            <DatePicker />
          </div>
        </div>
        <div className="diagram_details">
          <MonteCarloChart id="MonteCarlo" data={this.props.data} />
          <NoData show={!this.props.data.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.mc.data,
    isLoading: state.mc.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardMonteCarloChart);
